import React, { useRef, useState } from "react";
import { Button, Column, MasterDetail, GroupItem, Summary, TotalItem } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../../Componentes/Basicos/LVGridCabecera";
import { PaginaListado } from "../../../Componentes/Compuestos/Paginas/PaginaListado";
import VEN_Pedidos_Detalle from "../VEN_Pedidos_Detalle";
import { function_VEN_Pedidos_Cabecera_ListarComisiones } from "neftis7_apicaller/src/funciones/VEN/Pedidos/VEN_Pedidos_Cabecera";
import { function_ABM_EEX_Clientes_Leer } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";

export const VEN_Reporte_Pedidos_Comisiones = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const refRecargaListado = useRef(null);

  const handleDataLoaded = (data) => {
    setData(data);
  };

  return (
    <PaginaListado
      Titulo="COMISIONES PARA PEDIDOS"
      funcion={function_VEN_Pedidos_Cabecera_ListarComisiones}
      onDataLoaded={handleDataLoaded}
      refRecarga={refRecargaListado}
    >
      {loading && (
        <div className="spinner-overlay">
          <div className="card-body text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
          </div>
        </div>
      )}
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            dataSource={data}
            PageSize={11}
            id="gridContainer"
            keyExpr="IdPedido"
            puedeEditar = {false}
            puedeImprimir = {false}
            puedeMail = {false}
            puedeClonar = {false}
            AnchoBotonera={20}
          >
            <Summary>
              <TotalItem
                column="IdPedido"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />
              <TotalItem
                column="ImporteNeto"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteIVA"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteBonificaciones"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteRecargos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />
              <TotalItem
                column="Peso"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number" />

              <TotalItem
                column="Comision1SobreNeto"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />
              <TotalItem
                column="Comision2SobreNeto"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />
              <TotalItem
                column="Comision3SobreNeto"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />
                
              <TotalItem
                column="Comision1SobreTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />                
              <TotalItem
                column="Comision2SobreTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />                
              <TotalItem
                column="Comision3SobreTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />
                
              <GroupItem
                column="IdPedido"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`}
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteNeto"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteIVA"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteBonificaciones"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteRecargos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="Peso"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number"
                showInGroupFooter={true} />
            </Summary>

            <Column caption="Código" dataField="IdPedido" width="120" alignment="Right" dataType="number" />
            <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
            <Column caption="Fecha" dataField="FechaSinHora" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} visible={false} />
            <Column caption="Razón Social" dataField="ABM_EEX_Clientes_RazonSocial" width="100%" minWidth={100} alignment="Left" dataType="string" />
            <Column caption="Estado" dataField="TODOS_Estados_Descripcion" width="100" alignment="Left" dataType="string" />
            <Column caption="Creador" dataField="I_UsuarioCreador" width="130" alignment="Left" dataType="string" />
            <Column caption="Vendedor" dataField="Vendedor" width="100" alignment="Left" dataType="string" />

            <Column caption="Importes" alignment="Center">
              <Column caption="Moneda" dataField="ABM_CON_Monedas_Descripcion" width="70" alignment="Left" dataType="string" visible={false} />
              <Column caption="Cotización" dataField="Cotizacion" width="70" alignment="Right" dataType="number" format="currency" visible={false} />

              <Column caption="Neto" dataField="ImporteNeto" width="150" alignment="Right" dataType="number" format="currency" />
              <Column caption="Descuentos" dataField="ImporteBonificaciones" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Recargos" dataField="ImporteRecargos" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Desc.Items" dataField="ImporteBonificacionesItems" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Recs.Items" dataField="ImporteRecargosItems" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Total" dataField="ImporteTotal" width="150" alignment="Right" dataType="number" format="currency" />
            </Column>

            <Column caption="Porcentajes" alignment="Center">
              <Column caption="1" dataField="PorcentajeComision1" width="50" alignment="Right" dataType="number" />
              <Column caption="2" dataField="PorcentajeComision2" width="50" alignment="Right" dataType="number" />
              <Column caption="3" dataField="PorcentajeComision3" width="50" alignment="Right" dataType="number" />
            </Column>
            <Column caption="Comision Sobre Neto" alignment="Center">
              <Column caption="Com. 1" dataField="Comision1SobreNeto" width="110" alignment="Right" dataType="number" format="currency" />
              <Column caption="Com. 2" dataField="Comision2SobreNeto" width="110" alignment="Right" dataType="number" format="currency" />
              <Column caption="Com. 3" dataField="Comision3SobreNeto" width="110" alignment="Right" dataType="number" format="currency" />
            </Column>
            <Column caption="Comision Sobre Total" alignment="Center">
              <Column caption="Com. 1" dataField="Comision1SobreTotal" width="110" alignment="Right" dataType="number" format="currency" />
              <Column caption="Com. 2" dataField="Comision2SobreTotal" width="110" alignment="Right" dataType="number" format="currency" />
              <Column caption="Com. 3" dataField="Comision3SobreTotal" width="110" alignment="Right" dataType="number" format="currency" />
            </Column>
            <MasterDetail
              enabled={true}
              component={VEN_Pedidos_Detalle}
            />
          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
